import React from "react";
import Loading from '@/pages/intelligence/components/Loading';

export default function CommonLoading(props: any) {
  const { loadingHeight = 300 } = props;

  return <div
    style={{
      height: loadingHeight,
      color: '#444',
    }}
  >
    <Loading />
  </div>
}